export {renderBarLabel} from './BarLabel';
